import { Elements } from "@stripe/react-stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./PaymentForm";
import "../styles/PaymentPage.scss";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

export default function PaymentPage() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state?.clientSecret) {
    navigate("/");
    return null;
  }

  const ticketAmount = Number(state.amount || 0);
  const serviceCharge = Number(state.service_charge || 0);
  const stripeFee = Number(state.stripe_fee || 0);
  const total = ticketAmount + serviceCharge ;
  console.log("total ========> ",total)

  return (
    <div className="payment-wrapper">
      <div className="payment-card">
        <h2 className="payment-title">Complete Payment</h2>

        <div className="payment-summary">
          <div className="summary-row">
            <span className="label">Movie</span>
            <span className="value">{state.movie}</span>
          </div>

          <div className="summary-row">
            <span className="label">Ticket Price</span>
            <span className="value">€ {ticketAmount.toFixed(2)}</span>
          </div>

          <div className="summary-row">
            <span className="label">Service Charge</span>
            <span className="value">€ {serviceCharge.toFixed(2)}</span>
          </div>
          {/* <div className="summary-row">
            <span className="label">Processing Fee(Stripe)</span>
            <span className="value">€ {stripeFee.toFixed(2)}</span>
          </div> */}

          <div className="summary-divider" />

          <div className="summary-row total">
            <span>Total</span>
            <span>€ {total.toFixed(2)}</span>
          </div>
        </div>

        <Elements
          stripe={stripePromise}
          options={{ clientSecret: state.clientSecret }}
        >
          <PaymentForm bookingId={state.bookingId} />
        </Elements>
      </div>
    </div>
  );
}
